import { ComponentType } from 'react';
import {
    CleanContoursIcon,
    CropIcon,
    FillCavitiesIcon,
    RemoveSmallPartsIcon,
    SmoothIcon,
} from '~/assets/workspace-icons';
import {
    POST_PROCESSING_TAB_ORDER,
    PostProcessingTab,
} from '~/state/atoms/toolsAtoms';

/**
 * Name and icon for each operation the Post Processing panel offers.
 *
 * Two surfaces present this set — the menu the toolbar button expands
 * into, and the panel's own tab strip — and they must offer the same
 * operations under the same names in the same order, or picking an
 * operation would mean something different depending on which route the
 * user took. So both derive from here, and neither hand-lists anything.
 */
export const POST_PROCESSING_TAB_META: Record<
    PostProcessingTab,
    { labelId: string; Icon: ComponentType }
> = {
    thin: { labelId: 'postProcessing.tab.thin', Icon: CleanContoursIcon },
    fill: { labelId: 'postProcessing.tab.fill', Icon: FillCavitiesIcon },
    smooth: { labelId: 'postProcessing.tab.smooth', Icon: SmoothIcon },
    parts: { labelId: 'postProcessing.tab.parts', Icon: RemoveSmallPartsIcon },
    crop: { labelId: 'postProcessing.tab.crop', Icon: CropIcon },
};

/**
 * The operations in presentation order. Rendering order comes from
 * {@link POST_PROCESSING_TAB_ORDER} rather than from the record's own key
 * order, so the strip and the menu can never drift apart.
 */
export const POST_PROCESSING_TABS: {
    value: PostProcessingTab;
    labelId: string;
    Icon: ComponentType;
}[] = POST_PROCESSING_TAB_ORDER.map((value) => ({
    value,
    ...POST_PROCESSING_TAB_META[value],
}));
